import { render, staticRenderFns } from "./ConfirmClearAll.vue?vue&type=template&id=bdfe8104&scoped=true"
import script from "./ConfirmClearAll.vue?vue&type=script&lang=ts"
export * from "./ConfirmClearAll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfe8104",
  null
  
)

export default component.exports